import { ToastProvider } from 'react-native-toast-notifications';
import Toast from 'react-native-toast-notifications';

import { IBaseProps } from '@rbi-ctg/frontend';
import { rootToaster } from 'components/toaster/refs';

export const ToasterProvider = ({ children }: IBaseProps) => {
  return (
    <ToastProvider>
      {children}
      <Toast ref={x => (rootToaster.current = x)} />
    </ToastProvider>
  );
};
